var map = {
	"./prize-1-bm.webp": 2591,
	"./prize-1-cn.webp": 2592,
	"./prize-1.webp": 2593,
	"./prize-2-bm.webp": 2594,
	"./prize-2-cn.webp": 2595,
	"./prize-2.webp": 2596,
	"./prize-3-bm.webp": 2597,
	"./prize-3-cn.webp": 2598,
	"./prize-3.webp": 2599,
	"./prize-4-bm.webp": 2600,
	"./prize-4-cn.webp": 2601,
	"./prize-4.webp": 2602,
	"./star.svg": 2603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995;